import axiosApi from "@/plugins/axios.js";

export function initialize(store, router) {
  router.beforeEach((to, from, next) => {
    console.log("================== start router auth =======================");

    const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
    const currentUser = localStorage.getItem("heavenDashboardUser");

    console.log("currentUser===> ", currentUser);
    console.log("requiresAuth===> ", requiresAuth);

    if (requiresAuth && currentUser == null) {
      if (to.path === "/login") {
        next();
      } else {
        next("/login");
      }
    } else if (to.path === "/login" && currentUser != null) {
      next("/home");
    } else {
      next();
    }
  });

  axiosApi.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      if (!error.response) {
        return Promise.reject(error);
      }

      const code = error.response.status;

      if (code === 401) {
        /**
         * امسح كل بيانات السيشن
         * عدّل الأسماء دي حسب اللي عندك في المشروع
         */
        localStorage.removeItem("heavenDashboardToken");
        localStorage.removeItem("heavenDashboardUser");
        localStorage.removeItem("token");
        localStorage.removeItem("access_token");

        /**
         * لو عندك mutation في Vuex للـ logout
         * سيبها، ولو مش موجودة عادي مش هتكسر الكود
         */
        try {
          if (store && store.commit) {
            store.commit("logout");
          }
        } catch (e) {
          console.warn("Logout mutation not found");
        }

        /**
         * امنع إنه يعمل redirect لو هو أصلاً في صفحة login
         */
        if (router.currentRoute.path !== "/login") {
          router.push("/login");
        }
      }

      return Promise.reject(error);
    }
  );
}